import { convertApiAppNameToDisplay } from './convertAppNames'
import { convertActionToFrontEndValue } from './convertAction'

import { TActionsApiSubstitutes, TActions } from 'types/actions'
import { TAppTypesApiSubstitutes, TAppTypesDisplaySubsitutes } from 'types/apps'
import { TPermission } from 'types/permissions'

export type TPermissionReturned = {
  userRoleId: string
  action: TActions
  subject: TAppTypesDisplaySubsitutes
  uuid: string
}

// convert persmissions properties action and subject to frontend subtitudes
// ex. action form backend is "read" and we have to transform it into "VIEW"
// ex. subject form backend is "menumanager" and we have to transform it into "Menu Manager"
export const transformPermissionsToFrontendSubstitutesNames = (permissions: TPermission[]) => {
  return permissions?.map((permission) => {
    const convertedSubject = convertApiAppNameToDisplay(
      permission?.subject as TAppTypesApiSubstitutes
    )
    return {
      ...permission,
      action: convertActionToFrontEndValue(
        permission?.action as TActionsApiSubstitutes,
        convertedSubject
      ),
      subject: convertedSubject,
    }
  })
}
